<script>

import Layout from "../../layouts/main";

import PageHeader from "@/components/page-header";

import appConfig from "@/app.config";

import Customers from "@/services/Customers";

import modalAddEditLabel from "@/components/modals/customers/modalAddEditLabel";

import Swal from "sweetalert2";

export default {
  components: { Layout, PageHeader, modalAddEditLabel },
  page: {
    title: "Labels",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Labels",
      items: [
        {
          text: "Labels",
          active: true,
        },
      ],
      filterData: false,
      error: null,
      isBusy: false,
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: ["name", "description"],
      sortBy: "name",
      sortDesc: false,
      selectedLabel: null,
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "color", label: "Color", sortable: false },
        { key: "is_crm_label", label: "CRM", sortable: true },
        { key: "is_business_label", label: "Business", sortable: true },
        { key: "active", label: "Active", sortable: true },
        "action",
      ],
    };
  },
  mounted() {
    this.getLabels();
  },
  methods: {
    async getLabels() {
      try {
        this.filterData = true;
        this.toggleBusy();
        const response = await Customers.getCustomersLabel({ active: "all" });
        this.tableData = response.data.data || [];
        this.totalRows = this.tableData.length;
      } catch (error) {
        this.error = error.response?.data?.error || "";
        this.tableData = [];
        this.totalRows = 0;
      } finally {
        this.toggleBusy();
      }
    },
    openAddModal() {
      this.selectedLabel = null;
      this.$bvModal.show("add_label");
    },
    openEditModal(item) {
      this.selectedLabel = { ...item };
      this.$nextTick(() => {
        this.$bvModal.show("edit_label");
      });
    },
    deleteLabel(item) {
      Swal.fire({
        title: "Delete label?",
        text: `"${item.name}" will be permanently deleted.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Delete",
      }).then(async (result) => {
        if (!result.value) {
          return;
        }
        try {
          await Customers.deleteCustomersLabel(item.id);
          Swal.fire("Deleted", "Label removed successfully.", "success");
          this.getLabels();
        } catch (error) {
          const err = error.response?.data?.error;
          Swal.fire("Failed", Array.isArray(err) ? err.join(", ") : err || "Delete failed", "warning");
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    isTruthy(value) {
      return Number(value) === 1;
    },
    labelBadgeStyle(label) {
      const bg = label.color || "#6c757d";
      return {
        backgroundColor: bg,
        color: this.labelTextColor(bg),
      };
    },
    labelTextColor(hex) {
      if (!hex) {
        return "#fff";
      }
      const color = hex.replace("#", "");
      if (color.length !== 6) {
        return "#fff";
      }
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.6 ? "#212529" : "#fff";
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" v-show="filterData">
          <div class="card-body">
            <div>
              <a
                href="javascript:void(0);"
                class="btn btn-success waves-effect waves-light me-3"
                @click="openAddModal"
              >
                <i class="mdi mdi-plus me-2"></i>
                Add Label
              </a>
            </div>
            <div class="row mt-2">
              <div class="col d-inline-flex align-items-center">
                <h4 class="card-title m-0" style="margin-right: 15px !important;">
                  Total Labels: {{ totalRows }}
                </h4>
              </div>
            </div>
            <div class="row mt-4" v-show="filterData">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0" v-show="filterData">
              <b-table
                :items="tableData"
                :busy="isBusy"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                show-empty
                empty-text="No Data Found"
              >
                <template v-slot:cell(name)="data">
                  <span
                    class="badge label-badge"
                    :style="labelBadgeStyle(data.item)"
                    v-b-tooltip.hover
                    :title="data.item.description || data.item.name"
                  >
                    {{ data.item.name }}
                  </span>
                </template>

                <template v-slot:cell(color)="data">
                  <ul class="list-inline mb-0 d-flex" style="gap: 10px;">
                    <span
                      :style="{
                        display: 'block',
                        width: '20px',
                        height: '20px',
                        background: data.item.color || '#6c757d',
                        padding: '5px',
                        border: '1px solid black',
                      }"
                    ></span>
                    <span>{{ data.item.color || "—" }}</span>
                  </ul>
                </template>

                <template v-slot:cell(is_crm_label)="data">
                  <i
                    :class="isTruthy(data.item.is_crm_label) ? 'uil uil-check text-success' : 'uil uil-times text-muted'"
                  />
                </template>

                <template v-slot:cell(is_business_label)="data">
                  <i
                    :class="isTruthy(data.item.is_business_label) ? 'uil uil-check text-success' : 'uil uil-times text-muted'"
                  />
                </template>

                <template v-slot:cell(active)="data">
                  <span
                    class="badge"
                    :class="isTruthy(data.item.active) ? 'bg-success' : 'bg-secondary'"
                  >
                    {{ isTruthy(data.item.active) ? "Active" : "Inactive" }}
                  </span>
                </template>

                <template v-slot:cell(action)="data">
                  <a
                    href="javascript:void(0);"
                    class="px-2 text-danger"
                    title="Delete"
                    v-b-tooltip.hover
                    @click="deleteLabel(data.item)"
                  >
                    <i class="uil uil-trash-alt font-size-18"></i>
                  </a>
                  <a
                    href="javascript:void(0);"
                    class="px-2 text-primary"
                    title="Edit"
                    v-b-tooltip.hover
                    @click="openEditModal(data.item)"
                  >
                    <i class="uil uil-pen font-size-18"></i>
                  </a>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row" v-show="filterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modalAddEditLabel mode="add" @onRefresh="getLabels" />
      <modalAddEditLabel
        mode="edit"
        :key="selectedLabel ? selectedLabel.id : 'edit'"
        :labelData="selectedLabel"
        @onRefresh="getLabels"
      />
    </div>
  </Layout>
</template>

<style scoped>
.label-badge {
  font-weight: 500;
  font-size: 12px;
}
</style>

